import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// On an action inside a clickable container: the click runs this action only, not the container's too.
export default class StopPropagation extends BaseOption {
  static userInterfaceComponent = {
    label: "Keep click to this action",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    props: {
      options: [
        { label: "Yes", value: true, tooltip: "A surrounding clickable area does not also act" },
        { label: "No", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
